module.exports = __webpack_public_path__ + "static/media/Detsky_krem_na_opruzeniny_CBD_retina.6a77d113.jpg";